export enum TagTypes {
  Accounts = 'Accounts',
  AllocationRuns = 'AllocationRuns',
  AllocationStatistics = 'AllocationStatistics',
  Analytics = 'Analytics',
  Attestation = 'Attestation',
  LiveInventory = 'LiveInventory',
  // Only the `filter_lists` column of a live-inventory row. Kept separate from
  // LiveInventory so a filter-list edit doesn't refetch the percentile and
  // bucket aggregates, which cannot contain that column.
  LiveInventoryFilterLists = 'LiveInventoryFilterLists',
  Instrument = 'Instrument',
  Mark = 'Mark',
  Order = 'Order',
  Price = 'Price',
  RiskGroup = 'RiskGroup',
  RiskControl = 'RiskControl',
  User = 'User',
  UnifiedMarket = 'UnifiedMarket',
  Models = 'Models',
  Organization = 'Organization',
  Proposals = 'Proposals',
  // Immutable per-version snapshots; never invalidated by proposal mutations.
  ProposalVersion = 'ProposalVersion',
  RFQ = 'RFQ',
  RFQEvents = 'RFQEvents',
  TradingEvents = 'TradingEvents',
  Role = 'Role',
  Permission = 'Permission',
  ApiKey = 'ApiKey',
  IPAllowlist = 'IPAllowlist',
  AccountHoldings = 'AccountHoldings',
  CashRaise = 'CashRaise',
  CashRaiseSchedule = 'CashRaiseSchedule',
  SleeveRealignment = 'SleeveRealignment',
  EditChecks = 'EditChecks',
  TraderProfile = 'TraderProfile',
  FilterList = 'FilterList',
  PageConfig = 'PageConfig',
  Transaction = 'Transaction',
  ExecutionRules = 'ExecutionRules',
  InquiryPricingRules = 'InquiryPricingRules',
  OrderCosts = 'OrderCosts',
  AgentConversation = 'AgentConversation',
  AgentAddenda = 'AgentAddenda',
  Tags = 'Tags',
  TagAssignments = 'TagAssignments',
  AISkills = 'AISkills',
}

export const tagTypes = [
  TagTypes.Accounts,
  TagTypes.AllocationRuns,
  TagTypes.AllocationStatistics,
  TagTypes.Analytics,
  TagTypes.Attestation,
  TagTypes.LiveInventory,
  TagTypes.LiveInventoryFilterLists,
  TagTypes.Instrument,
  TagTypes.Mark,
  TagTypes.Order,
  TagTypes.Price,
  TagTypes.RiskGroup,
  TagTypes.RiskControl,
  TagTypes.User,
  TagTypes.UnifiedMarket,
  TagTypes.Models,
  TagTypes.Organization,
  TagTypes.Proposals,
  TagTypes.ProposalVersion,
  TagTypes.RFQ,
  TagTypes.RFQEvents,
  TagTypes.TradingEvents,
  TagTypes.Role,
  TagTypes.Permission,
  TagTypes.ApiKey,
  TagTypes.IPAllowlist,
  TagTypes.AccountHoldings,
  TagTypes.CashRaise,
  TagTypes.CashRaiseSchedule,
  TagTypes.SleeveRealignment,
  TagTypes.TraderProfile,
  TagTypes.FilterList,
  TagTypes.PageConfig,
  TagTypes.Transaction,
  TagTypes.ExecutionRules,
  TagTypes.InquiryPricingRules,
  TagTypes.EditChecks,
  TagTypes.OrderCosts,
  TagTypes.AgentConversation,
  TagTypes.AgentAddenda,
  TagTypes.Tags,
  TagTypes.TagAssignments,
  TagTypes.AISkills,
]
